import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../../../core/layout/Card';
import { min } from 'lodash';
import Async from '../../../../core/layout/Async';

export default function AverageLevelChart(props) {
  const courses = ['Beginner', 'Pre A1', 'A1', 'A1+', 'A2', 'A2+', 'B1', 'B1+', 'B2', 'B2+', 'C1'];
  let height = ((courses.findIndex((course) => course === props.course) + 1) / courses.length) * 100 - 5;

  return (
    <Card title="Average Level">
      <Async fetching={props.isFetching}>
        {props.course !== null ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div
              style={{
                width: '30px',
                height: '400px',
                borderRadius: '35px',
                backgroundColor: '#e8e8e8',
                position: 'relative',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column-reverse',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  width: '100%',
                  height: props.course === 'C1' ? '100%' : `${min([100, height])}%`,
                  backgroundColor: '#30A99D',
                }}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '400px',
                marginLeft: '20px',
              }}
            >
              {courses.reverse().map((course) => (
                <span style={{ fontWeight: props.course === course ? 'bold' : 'normal' }}>{course}</span>
              ))}
            </div>
          </div>
        ) : (
          <span>No Placement Tests found.</span>
        )}
      </Async>
    </Card>
  );
}

AverageLevelChart.propTypes = {
  course: PropTypes.string.isRequired,
  isFetching: PropTypes.bool,
};

AverageLevelChart.defaultProps = {
  isFetching: false,
};
